import { AlertDialogModel } from "../Managers/dataStructures";
import { ActivityIndicator } from "../Managers/utilityComponents";
import AlertDialog from "./AlertDialog";

export default function WaitingDialog() {
  return (
    <div
      className="relative z-50"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            className={
              "relative transform overflow-hidden rounded-lg px-4 pb-4 pt-5 transition-all sm:my-8 sm:p-6 lg:w-2/5 w-4/5"
            }
          >
            {ActivityIndicator(1)}
          </div>
        </div>
      </div>
    </div>
  );
}

export function AlertWaitingDialog(
  alertItem: AlertDialogModel,
  close: () => void
) {
  return (
    <div
      className="relative z-50"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            className={
              "relative transform overflow-hidden rounded-lg px-4 pb-4 pt-5 transition-all sm:my-8 sm:p-6 lg:w-2/5 w-4/5"
            }
          >
            <AlertDialog item={alertItem} closeDialog={close} />
          </div>
        </div>
      </div>
    </div>
  );
}
